import { fromJS } from 'immutable';

import {
    FEEDS_SET_FIELD_MAP,
    FEEDS_REMOVE_FIELD_MAP,
    FEEDS_ADD_FIELD_MAP,
    FEEDS_INIT_FIELD_MAP,
    FEEDS_HYDRATE,
} from './actions';

/** Feeds Store **/
/*
feeds: {
    Contact: {
        field_map: [
            { sf: 'FirstName', gf: '1.3' }, //Name (First)
            ...
        ]
    }
}
*/
const feedsInitialState = fromJS({
    feeds: {}
})

export const feedsReducer = function (state = feedsInitialState, action) {
    switch (action.type) {
        case FEEDS_SET_FIELD_MAP:
            {
                const { sobjectName, idx, sf, gf } = action;

                let feeds = state.get('feeds').toJS();

                if (feeds.hasOwnProperty(sobjectName)) {
                    if (sf != undefined) {
                        feeds[sobjectName].field_map[idx].sf = sf;
                    }

                    if (gf != undefined) {
                        feeds[sobjectName].field_map[idx].gf = gf;
                    }
                }

                return state.set('feeds', fromJS(feeds));
            }

        case FEEDS_REMOVE_FIELD_MAP:
            {
                const { sobjectName, idx } = action;

                let feeds = state.get('feeds').toJS();

                if (feeds.hasOwnProperty(sobjectName)) {
                    feeds[sobjectName].field_map.splice(idx, 1);
                }

                return state.set('feeds', fromJS(feeds));
            }

        case FEEDS_ADD_FIELD_MAP:
            {
                const { sobjectName } = action;

                let feeds = state.get('feeds').toJS();

                if (!feeds.hasOwnProperty(sobjectName)) {
                    feeds[sobjectName] = { field_map: [{sf: '', gf: ''}] };
                }

                feeds[sobjectName].field_map.push({sf: '', gf: ''});

                return state.set('feeds', fromJS(feeds));
            }

        case FEEDS_INIT_FIELD_MAP:
            {
                const { sobjectName } = action;

                let feeds = state.get('feeds').toJS();

                if (!feeds.hasOwnProperty(sobjectName)) {
                    feeds[sobjectName] = { field_map: [{sf: '', gf: ''}] };
                }

                return state.set('feeds', fromJS(feeds));
            }

        case FEEDS_HYDRATE:
            {
                const { feeds } = action;

                return state.set('feeds', fromJS(feeds));
            }
    }

    return state;
}
